






















































import Super from "@/pv4-super-class"
import { Component, Prop } from "vue-property-decorator"

@Component
export default class LoadingLogo extends Super {
  @Prop({ type: String, required: false, default: "" }) loadingText!: string
  @Prop({ type: Boolean, required: false, default: false }) logoOnly!: boolean
}
